import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  // Prevent scrolling when modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  return <AnimatePresence data-id="element-14">
      {isOpen && <>
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50" data-id="element-15" />
          <div className="fixed inset-0 flex items-center justify-center p-4 z-50 pointer-events-none" data-id="element-16">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} className="bg-dark-light border border-sage-dark rounded-2xl shadow-2xl w-full max-w-2xl max-h-[85vh] flex flex-col pointer-events-auto" data-id="element-17">
              <div className="flex items-center justify-between p-6 border-b border-sage-dark" data-id="element-18">
                <h2 className="text-2xl font-serif font-bold text-cream" data-id="element-19">
                  {title}
                </h2>
                <button onClick={onClose} className="text-cream/60 hover:text-coral transition-colors p-2 rounded-full hover:bg-dark-muted" data-id="element-20">
                  <X className="w-6 h-6" data-id="element-21" />
                </button>
              </div>
              <div className="p-6 overflow-y-auto text-cream/80 prose prose-invert prose-sage max-w-none" data-id="element-22">
                {children}
              </div>
            </motion.div>
          </div>
        </>}
    </AnimatePresence>;
}